import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SHRDashboardDTO  {
    _originalTypeClassName = "zSHR.BO.SHRDashboardDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SHRDashboardDTO.translate = translateService;
}
this.DailyLeaves = [];
this.YearOfRecruiment = null;
this.AvailableAnnualLeaveDays = null;
this.UsedAnnualLeaveDays = null;
this.RemainingAnnualLeaveDays = null;
this.PreviousYearRemainingLeaveDays = null;
this.UseUntil = null;
this.LastUpdate = null;
this.DepartmentName = null;
this.DepartmentId = null;
this.Supervisor = null;
this.PersonalInfoChangePendingRequests = null;
this.LeavesPendingRequests = null;
this.SHRDashboardDTOKey = null;
this._key = this.SHRDashboardDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
YearOfRecruiment:any;
AvailableAnnualLeaveDays:any;
UsedAnnualLeaveDays:any;
RemainingAnnualLeaveDays:any;
PreviousYearRemainingLeaveDays:any;
UseUntil:any;
LastUpdate:any;
DepartmentName:any;
DepartmentId:any;
Supervisor:any;
PersonalInfoChangePendingRequests:any;
LeavesPendingRequests:any;
DailyLeaves:any;
private _SHRDashboardDTOKey:any;
get SHRDashboardDTOKey(): any {
    return this._SHRDashboardDTOKey;
  }
set SHRDashboardDTOKey(value: any) {
    this._SHRDashboardDTOKey = value;
    this._key = value;
  }
static setDailyLeaves = ($this, items) => {
                if (items == null) items = [];
                if ($this.DailyLeaves == null) $this.DailyLeaves = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DailyLeaves.length > 0) {
                    Domain.SHRDashboardDTO.removeDailyLeaves($this, $this.DailyLeaves[0]);
                }

                Domain.SHRDashboardDTO.addManyDailyLeaves($this, copyItems);
            }
static addManyDailyLeaves = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SHRDashboardDTO.addDailyLeaves($this, items[i]);
                }
            }
static addDailyLeaves = ($this, item) => {
                if ($this.DailyLeaves == null) $this.DailyLeaves = [];
                if (item == null || $this.DailyLeaves.indexOf(item) > -1) return;
                $this.DailyLeaves.push(item);
}
static addRangeDailyLeaves = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SHRDashboardDTO.addDailyLeaves($this, item));
            }
static removeDailyLeaves = ($this, item) => {
                if ($this == null || $this.DailyLeaves == null || $this.DailyLeaves.indexOf(item) === -1) return;
                var _index = $this.DailyLeaves.indexOf(item);
                $this.DailyLeaves.splice(_index, 1);
}
static clearDailyLeaves = ($this) => { $this.DailyLeaves = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SHRDashboardDTOKey == null || $this.SHRDashboardDTOKey == 0;
            }


}